import React from 'react';
import { Box, Stack } from '@mui/material';
import { DatePicker } from '../../../../../forms';
import { IPeriodSelector } from './interfaces';
import dayjs from 'dayjs';

export const PeriodSelector: React.FC<IPeriodSelector> = ({
  value: period,
  onChange,
}): JSX.Element => {
  const handleFromDateChange = (value: dayjs.Dayjs | null) => {
    onChange({
      from: value,
      to: period?.to,
    });
  };

  const handleToDateChange = (value: dayjs.Dayjs | null) => {
    onChange({
      from: period?.from,
      to: value,
    });
  };

  return (
    <Stack rowGap="8px">
      <DatePicker
        label={'from'}
        onChange={handleFromDateChange}
        selectedDate={period?.from}
        maxDate={period?.to || undefined}
        error={false}
        required
      />
      <DatePicker
        label={'to'}
        onChange={handleToDateChange}
        selectedDate={period?.to}
        minDate={period?.from || undefined}
        error={false}
        required
      />
    </Stack>
  );
};
